import React from "react";
import { connect } from "react-redux";
import { getUsers } from "../redux/actions/usersActions";
import Table from "../components/Table";
import Actions from "../components/Table/Actions";
import Header from "../components/Page/Header";
import Moment from "react-moment";
import Tooltip from "@material-ui/core/Tooltip";
import { Link } from "react-router-dom";
import AddNew from "../components/Advertising/AddNew";
import ChangePassword from "../components/User/ChangePassword";
import Delete from "../components/User/Delete";

function Advertising(props) {
  const { users, data, loading } = props.users;
  const columns = [
    {
      id: "name",
      Header: "Name",
      filterable: true,
      accessor: (d) => d._id,
      Cell: (props) => (
        <Link to={`/advertiser/${props.original._id}`}>
          <strong>{props.original.username}</strong>
        </Link>
      ),
    },
    {
      id: "email",
      Header: "E-mail",
      filterable: true,
      accessor: (d) => d._id,
      Cell: (props) => (
        <strong>
          <a
            style={{ color: "inherit", textTransform: "lowercase" }}
            href={`mailto:${props.original.email} `}
          >
            {props.original.email}{" "}
          </a>
        </strong>
      ),
    },
    {
      id: "phone",
      Header: "Phone",
      accessor: (d) => d._id,
      Cell: (props) => (
        <strong>
          <a
            style={{ color: "inherit", textTransform: "lowercase" }}
            href={`tel:+${props.original.phone} `}
          >
            {props.original.phone}
          </a>
        </strong>
      ),
    },
    {
      id: "createdAt",
      Header: "Date",
      accessor: (d) => d._id,
      Cell: (props) => (
        <strong>
          <Moment>{props.original.createdAt}</Moment>
        </strong>
      ),
    },
    {
      id: "refId",
      Header: "RefId",
      accessor: (d) => d._id,
      Cell: (props) => <strong>{props.original.refId}</strong>,
    },
    {
      id: "actions",
      Header: "Actions ",
      accessor: (d) => d._id,
      Cell: (props) => (
        <Actions>
          <Tooltip arrow title="Edit this user">
            <ChangePassword userId={props.original._id} />
          </Tooltip>
          {/* <Tooltip arrow title='Delete this user'>
            <Delete userId={props.original._id} />
          </Tooltip> */}
        </Actions>
      ),
    },
  ];
  return (
    <React.Fragment>
      <Header title="Advertising " size={data.total}>
        <AddNew />
      </Header>
      <Table
        data={users}
        columns={columns}
        loading={loading}
        page={!data.pagination ? 0 : data.pagination.current - 1}
        pages={!data.pagination ? 1 : data.pagination.total}
        onFetchData={(state) => {
          var queryString = state.filtered
            .map((key) => key.id + "=" + key.value)
            .join("&");
          let query = `?page=${state.page + 1}&type=4&${queryString}`;
          props.getUsers(query);
        }}
        noDataText="No advertising users"
      />
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({
  users: state.users,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, { getUsers })(Advertising);
